/**
 * InsightsFeed Page
 * v1.0 - 2026-05-05 - WOW-RAG-CONTENT-01d: dedicated full-feed surface for AI Insights.
 *
 * Renders the same InsightsPanel that the Dashboard uses, on its own full-width
 * route at /dashboard/insights. The InsightsPanel fetches its own data via
 * /api/dashboard/recommendations (capped server-side at 10 records by
 * dashboard_api.py:1395). API extension is out-of-scope for 01d (Q1 decision);
 * defer pagination/larger feed to a separate story when content volume justifies.
 */
import React from 'react';
import { Box, Container } from '@mui/material';
import TopBar from '../components/TopBar';
import InsightsPanel from '../components/InsightsPanel';

const InsightsFeed: React.FC = () => {
  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <TopBar title="AI Insights" subtitle="Cross-source insights tailored to your business" />
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <InsightsPanel />
      </Container>
    </Box>
  );
};

export default InsightsFeed;
